import { render, staticRenderFns } from "./CdpSettings.vue?vue&type=template&id=6846766c&scoped=true"
import script from "./CdpSettings.vue?vue&type=script&lang=js"
export * from "./CdpSettings.vue?vue&type=script&lang=js"
import style0 from "./CdpSettings.vue?vue&type=style&index=0&id=6846766c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6846766c",
  null
  
)

export default component.exports